import { render, staticRenderFns } from "./RbuEditionConfigure.vue?vue&type=template&id=2e7aea2f"
import script from "./RbuEditionConfigure.vue?vue&type=script&lang=js"
export * from "./RbuEditionConfigure.vue?vue&type=script&lang=js"
import style0 from "./RbuEditionConfigure.vue?vue&type=style&index=0&id=2e7aea2f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports